import PANELOADER_HOME from '../../APP/page/paneloader/paneloaders/PANELOADER_HOME.js';
import PANELOADER_BLOG from '../../APP/page/paneloader/paneloaders/PANELOADER_BLOG.js';
/** A Factory for constructing PANE Loaders */
export default class PANEFACTORY {
    page;
    // public loader: any;
    /** Construct a pane factory
        @param {PAGE} page PAGE
    */
    constructor(page) {
        this.page = page;
        // this.loader = page.loader;
    }
    /** Construct a PaneLoader based on the given Pane Label
        @param {string} paneLabel Pane Label
        @returns {PANELOADER} Pane Loader
    */
    makePane(model) {
        switch (model.name) {
            case 'PANELOADER_HOME':
                return new PANELOADER_HOME(this.page, model);
            case 'PANELOADER_BLOG':
                return new PANELOADER_BLOG(this.page, model);
            default:
                throw new Error('Undefined PANELOADER: ' + model.name);
        }
    }
}
